import React, { useState, useEffect } from "react";
import { Row, Col, Label, Button, FormGroup, Input } from "reactstrap";
import ApiCaller from "../../../../../../api/apiCaller";
import { CreateZoneModalInputProps } from "./type";

import "./index.css";
import t from "utils/Lang";

export default function CreateZoneModal({
  mode,
  inputZone,
  onSave,
}: CreateZoneModalInputProps) {
  const defaultZone = inputZone || {
    name: "",
    zone_level: "",
  };
  const [zone, setZone] = useState<any>(defaultZone);
  const updateAttr = (attrName: string, value: any) => {
    const newZone = { ...zone };
    newZone[attrName] = value;
    setZone(newZone);
  };
  const deleteZone = async () => {
    const res = await ApiCaller.put(`zone/${zone.id}`, {
      is_active: false,
    });
    if (res.status === "ok") {
      if (onSave) {
        onSave({ isDelete: true });
      }
    }
  };
  const saveZone = async () => {
    let bodyToSubmit = zone;
    let res = null;
    if (mode === "edit" || mode === "update") {
      // Remove nested zone element
      if (bodyToSubmit && bodyToSubmit.zone) delete bodyToSubmit.zone;
      res = await ApiCaller.put(`zone/${zone.id}`, {
        name: bodyToSubmit.name,
        zone_level: bodyToSubmit.zone_level,
      });
    } else {
      res = await ApiCaller.post("zone/", bodyToSubmit);
    }
    if (res.status === "ok") {
      if (onSave) {
        onSave();
      }
    }
  };
  useEffect(() => {
    setZone(inputZone);
  }, [inputZone]);
  return (
    <div className="create-zone-container">
      <h3>
        <span>
          {mode === "create"
            ? `${t().zone_element__create_new} `
            : `${t().action__edit} `}
        </span>
        {zone?.name && <span>{zone.name}</span>}
      </h3>
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Label>{t().zone_element__name}</Label>
            <Input
              placeholder={t().zone_element__name_placeholder}
              value={zone.name}
              onChange={(e) => updateAttr("name", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>{t().zone_element__zone_level}</Label>
            <Input
              type="select"
              value={zone.zone_level}
              onChange={(e) => updateAttr("zone_level", e.target.value)}
            >
              <option value="">{t().zone_element__select_level}</option>
              <option value="city">{t().zone_element__city}</option>
              <option value="district">{t().zone_element__district}</option>
              <option value="ward">{t().zone_element__ward}</option>
            </Input>
          </FormGroup>
        </Col>
        <Col xs={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <FormGroup>
              <Button color="success" onClick={saveZone}>
                {t().action__save}
              </Button>
            </FormGroup>
            <div style={{ width: 15 }} />
            {mode === "edit" && (
              <FormGroup>
                <Button color="danger" onClick={deleteZone}>
                  {t().action__delete}
                </Button>
              </FormGroup>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}
